import React, { Component } from 'react';

import { 
    Box,
    IconButton,
    Dialog
} from '@material-ui/core';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';


class JobsDialog extends Component {

    constructor(props){
        super(props);
    
        let open = ((props.open === true || props.open === false) ? props.open : false);
        let isCloseBtn = ((props.isCloseBtn === true || props.isCloseBtn === false) ? props.isCloseBtn : true);
        let fullWidth = ((props.fullWidth === true || props.fullWidth === false) ? props.fullWidth : true);
        let maxWidth = (props.maxWidth) ? props.maxWidth : 'sm';
        let closeBtnPosition = (props.closeBtnPosition) ? props.closeBtnPosition : 'out';
        let className = (props.className) ? props.className : '';
        let scroll = (props.scroll) ? props.scroll : 'body';

        if(maxWidth === 'xxl'){
            maxWidth = false;
        }

        this.state = {
            open: open,
            isCloseBtn: isCloseBtn,
            closeBtnPosition: closeBtnPosition,
            fullWidth: fullWidth,
            maxWidth: maxWidth,
            className: className,
            scroll: scroll,
        }
    }


    componentWillReceiveProps(nextProps) {
		if (nextProps.open !== this.state.open) {
			this.setState({
				open: nextProps.open
			});
		}
	}


    handleClose = (e, r) => {
        if(r !== 'backdropClick'){
            this.setState({
                open: false
            });
    
            if(this.props.onClose){
                this.props.onClose();
            }
        }
    }


    render() {
        return <Dialog
            className={"jobs-dialog-component " + this.state.className}
            open={this.state.open}
            onClose={this.handleClose}
            fullWidth={this.state.fullWidth}
            maxWidth={(this.state.fullWidth) ? null : this.state.maxWidth}
            scroll={this.state.scroll}
            disableEnforceFocus={true}
        >
            <Box position={"relative"} p={3}>
                {this.state.isCloseBtn && 
                <IconButton 
                    className={this.state.closeBtnPosition === "out" ? "dialog-close-btn-out" : "dialog-close-btn-in"}
                    onClick={this.handleClose}
                >
                    <HighlightOffIcon />
                </IconButton>}
                {this.props.children}
            </Box>
        </Dialog>;
    }
}


export default JobsDialog;